// Estado real de una venta para mostrar en pantalla. ventas.estado se fija al crear la
// venta ('pendiente' si fue a credito) y nunca cambia al pagarse, asi que una venta a
// credito se considera pagada cuando ya no le queda saldo por cobrar.
export function saldoVenta(v: any): number {
  return (Number(v?.saldo_credito_productos) || 0) + (Number(v?.saldo_credito_servicios) || 0);
}

export function ventaPagada(v: any): boolean {
  return v?.estado === 'pagado' || saldoVenta(v) <= 0.004;
}
